import { IContentDefinition, StaticPerkAccordionType } from '../../typings';
import { EDRPerkElectricityContent } from '../EverydayRewards/EverydayRewardsVariableElectricityPromobox';
import { EDRPerkDualPRCHContent } from '../EverydayRewards/EverydayRewardsVariableDualPRCHPromobox';
import { EDRPerkDualContent } from '../EverydayRewards/EverydayRewardsVariableDualPromobox';
import { EDRPerkElectricityPRCHContent } from '../EverydayRewards/EverydayRewardsVariableElectricityPRCHPromobox';
import { EDRPerkGasPRCHContent } from '../EverydayRewards/EverydayRewardsVariableGasPRCHPromobox';
import { EDRPerkGasContent } from '../EverydayRewards/EverydayRewardsVariableGasPromobox';
import { EDRPerkContent } from '../EverydayRewards/EverydayRewardsVariablePromobox';
import { InternetOfferPerk } from './internetOfferPerk';

export const createPromoBoxAccordion = (): IContentDefinition<StaticPerkAccordionType[] | null> => {
  return {
    // a new way of organizing content using a flat structure with tags rather than a hierarchical structure,
    // both structures can co-exist with one another, but preference is given to this new way of classifying and finding content,
    // note: order of contents matters because the first matching record is returned
    contents: [
      {
        data: [InternetOfferPerk, EDRPerkElectricityPRCHContent],
        tags: ['fuel:electricity', 'connection:scenario:cust_prch'],
      },
      {
        data: [InternetOfferPerk, EDRPerkGasPRCHContent],
        tags: ['fuel:gas', 'connection:scenario:cust_prch'],
      },
      {
        data: [InternetOfferPerk, EDRPerkDualPRCHContent],
        tags: ['fuel:dual', 'connection:scenario:cust_prch'],
      },
      {
        data: [InternetOfferPerk, EDRPerkElectricityContent],
        tags: ['fuel:electricity'],
      },
      {
        data: [InternetOfferPerk, EDRPerkGasContent],
        tags: ['fuel:gas'],
      },
      {
        data: [InternetOfferPerk, EDRPerkDualContent],
        tags: ['fuel:dual'],
      },
      {
        data: [EDRPerkContent],
        tags: [],
      },
    ],
  } as IContentDefinition<StaticPerkAccordionType[] | null>;
};
